function initializeSliders(wrapperElement) {
  const sliders = wrapperElement.querySelectorAll('.card-img-slider');

  sliders.forEach((slider) => {
    let currentIndex = 0;
    const slides = slider.querySelectorAll('.slide');
    const dots = slider.querySelectorAll('.dot');
    const prevArrow = slider.querySelector('.slider-arrow-left');
    const nextArrow = slider.querySelector('.slider-arrow-right');
    const sliderNavigation = slider.querySelector('.slider-navigation');

    if (sliderNavigation) {
      sliderNavigation.addEventListener('click', (e) => {
        e.preventDefault();
      });
    }

    function showSlide(index) {
      if (index >= slides.length) index = 0;
      if (index < 0) index = slides.length - 1;
      slides.forEach((slide, i) => {
        slide.style.transform = `translateX(${-index * 100}%)`;
        dots[i].classList.toggle('active', i === index);
      });
      currentIndex = index;
    }

    if (prevArrow) {
      prevArrow.addEventListener('click', (e) => {
        e.preventDefault();
        showSlide(currentIndex - 1);
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', (e) => {
        e.preventDefault();
        showSlide(currentIndex + 1);
      });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        showSlide(i);
      });
    });

    let startX = 0;
    let currentTranslate = 0;
    let previousTranslate = 0;
    let slideWidth = slider.clientWidth;
    let dragging = false;

    slider.addEventListener(
      'touchstart',
      (e) => {
        startX = e.touches[0].clientX;
        previousTranslate = currentTranslate;
        dragging = true;
        slider.style.transition = 'none';
      },
      { passive: true }
    );

    slider.addEventListener('touchmove', (e) => {
      if (dragging) {
        const currentX = e.touches[0].clientX;
        const moveX = currentX - startX;

        if ((currentIndex === 0 && moveX > 0) || (currentIndex === slides.length - 1 && moveX < 0)) {
          return;
        }

        currentTranslate = previousTranslate + moveX;
        slides.forEach((slide) => {
          slide.style.transform = `translateX(${currentTranslate}px)`;
        });

        e.preventDefault();
      }
    });

    slider.addEventListener(
      'touchend',
      (e) => {
        dragging = false;
        const endX = e.changedTouches[0].clientX;
        const distanceMoved = endX - startX;
        if (Math.abs(distanceMoved) > slideWidth / 3) {
          if (distanceMoved < 0 && currentIndex < slides.length - 1) {
            showSlide(currentIndex + 1);
          } else if (distanceMoved > 0 && currentIndex > 0) {
            showSlide(currentIndex - 1);
          } else {
            showSlide(currentIndex);
          }
        } else {
          showSlide(currentIndex);
        }
      },
      { passive: true }
    );

    showSlide(0);
  });
}
